// utils/donorGemDisplay.js

export function normalizeDonorGem(source) {
  if (source?.donorGem && typeof source.donorGem === "object") {
    return source.donorGem;
  }

  if (!source?.isKofiDonor) {
    return {
      showBadge: false,
      variant: null,
      isActive: false,
      choicePending: false,
      inactiveMonths: 0,
      fadeOpacity: 0,
      lastSupportAt: null,
    };
  }

  let variant = "one-time";
  if (source.isKofiPremiumDonor) variant = "premium";
  else if (source.isKofiSubscriber) variant = "subscriber";

  return {
    showBadge: true,
    variant,
    isActive: true,
    choicePending: false,
    inactiveMonths: 0,
    fadeOpacity: 1,
    lastSupportAt: null,
  };
}

export function resolveDonorGemColorVariant(donorGem) {
  if (!donorGem?.showBadge) return null;
  if (donorGem.variant === "inactive") {
    return donorGem.historicalVariant || "one-time";
  }
  return donorGem.variant;
}

function supportLevelLabel(colorVariant) {
  if (colorVariant === "premium") return "benefactor";
  if (colorVariant === "subscriber") return "patron";
  return "supporter";
}

export function formatDonorGemTooltip(donorGem) {
  if (!donorGem?.showBadge) return "";

  const colorVariant = resolveDonorGemColorVariant(donorGem);

  if (donorGem.isActive) {
    return supportLevelLabel(colorVariant);
  }

  if (donorGem.choicePending) return "choice pending";

  const formerLabel = `former ${supportLevelLabel(colorVariant)}`;
  const months = Number(donorGem.inactiveMonths) || 0;
  if (months <= 0) return formerLabel;
  if (months === 1) return `${formerLabel} · last support 1 month ago`;
  return `${formerLabel} · last support ${months} months ago`;
}

export function formatDonorGemLabel(donorGem) {
  if (!donorGem?.showBadge) return "";

  if (donorGem.isActive) {
    return supportLevelLabel(resolveDonorGemColorVariant(donorGem));
  }

  if (donorGem.choicePending) return "choice pending";

  return `former ${supportLevelLabel(resolveDonorGemColorVariant(donorGem))}`;
}

export function donorGemFadeClass(donorGem) {
  if (!donorGem?.showBadge || donorGem.isActive) return "";
  const opacity = Number(donorGem.fadeOpacity);
  if (!Number.isFinite(opacity) || opacity >= 1) return "";
  const bucket = Math.max(0, Math.min(10, Math.round(opacity * 10)));
  return `donor-gem-badge--fade-${bucket}`;
}
